import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4z8um3dept: FaireBrandEntity = {
  token: "b_4z8um3dept",
  type: "brand",
  name: "Sheer Trend",
  avatarUrl:
    "https://cdn.faire.com/fastly/8f01d5a60df2a14a7d755b15497a11629e9ef41e59f334ca58790d365c558a16.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f38457e33618e94599224138cf4599d9d6a30f4e50ab88cfe2064c13c4e9773b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8f01d5a60df2a14a7d755b15497a11629e9ef41e59f334ca58790d365c558a16.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f38457e33618e94599224138cf4599d9d6a30f4e50ab88cfe2064c13c4e9773b.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 145,
  rating: 3.8,
  reviewCount: 312,
  isInsider: true,
  description:
    "Welcome to Sheer Trend: Your Ultimate Source for Wholesale Women's Apparel\n\nWe haven't raised the prices, and the prices include tax. There will be no additional tax charges.\n\nDiscover Sheer Trend - the leading wholesaler of women's apparel, proudly headquartered in the vibrant fashion hub of Los Angeles. Our extensive selection encompasses a diverse array of stylish and on-trend clothing options, tailored exclusively for women. If your quest involves procuring top-notch, fashionable women's clothing, your search culminates here.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:26.604Z",
    importedBy: "entity-db-cli",
  },
};
